<template>
	<div class="header" :class="headclass">
		<div class="wrap">
			<div class="top fiex" style="justify-content:flex-end;">
				<dl style="cursor: pointer;" @click="goto('/other/theater')">
					<dt class="fiex">
						<i style="height:15px"><img src="../../../assets/images/w1.png" /></i>
						<div class="mag-l-10 mag-r-5 c999">{{$store.state.cityList.cinemaInfo.cinemaName}}</div>
						<span class="mag-t-3" style="height:6px"><img src="../../../assets/images/w2.png" /></span>
					</dt>
				</dl>

				<div class="top-login fiex">
					<a v-if="!userInfo.ltoken" href="#/login/index" class="bon com-bon mag-r-20">{{ lanuage("10251", "Log in") }}</a>
					<div v-else class="fiex login_top_mem">
						<img class="mag-r-5" src="../../../assets/images/X3.png" />
						<img src="../../../assets/images/icon2.png" />
						<div class="box">
							<dl>
								<dt>
									<a href="#/member/index" class="fiex">
										<img :src="userInfo.avatar?userInfo.avatar:defaultPhoto" />
										<div class="fiex1 mag-l-10">
											<p class="f-18 fff mag-b-5">{{userInfo.nickName}}</p>
											<p class="c999">{{userInfo.mobile}}</p>
										</div>
									</a>
								</dt>
								<dd>
									<ul class="cf">
										<li><a href="#/member/order">{{ lanuage("10005", "My Order") }}</a></li>
										<li><a href="#/member/coupon">{{ lanuage("10006", "Coupon") }}</a></li>
										<!-- <li><a href="#/member/coupon">Membership Card</a></li> -->
										<li><a href="#/member/faq">{{ lanuage("10011", "FAQ") }}</a></li>
										<!-- <li><a href="#/member/wantsee">What i want to see </a></li> -->
										<li><a  @click="quit" href="javascript:;">{{ lanuage("10012", "Drop Out") }}</a></li>
									</ul>
								</dd>                       
								           
								         
							</dl>
						</div>
					</div>
					<span v-if="userInfo.ltoken" class="login_top_msg">
						<a href="#/member/message">
							<!-- <i>3</i> -->
							<img src="../../../assets/images/X4.png" />
						</a>
					</span>
				</div>
				<div class="top-share">
					<a href="https://www.facebook.com/dadicinema" target="_blank"  class="bon-2 bon"><img src="../../../assets/images/icon4.png"  /></a>
					<a href="https://www.instagram.com/dadicinema_my/" target="_blank"  class="bon-3 bon"><img src="../../../assets/images/icon5.png"  /></a>
				</div>
				<div class="top-app">
					<div class="bon fiex"><p class="fiex1" style="line-height: 12px;">
						<img class="s1"  src="../../../assets/images/icon3.png"  />
						<img class="s2"  src="../../../assets/images/icon33.png"  />
					</p> </div>
					<div class="child">
						<div class="mag-t-30 f-down">
							<p>
								<a href="https://appgallery.huawei.com/app/C104281553"  target="_blank" class="fiex">
									<img src="../../../assets/images/d1.png" />
									<!-- <span class="mag-l-10">Android Down</span> -->
								</a>
							</p>
							<p>
								<a href="https://apps.apple.com/app/id1559855311" target="_blank" class="fiex">
									<img src="../../../assets/images/d2.png" />
									<!-- <span  class="mag-l-10">Apple down</span> -->
								</a>
							</p>
						</div>
					</div>
				</div>
			</div>

			<div class="menu-box cf fiex">
				<div class="logo "><a href="#/index"><img src="../../../assets/images/logo.png" /></a></div>
				<div class="fiex1">
					<div class="menu  fiex">
						<ul class="f-b fiex1 fiex f-18" style="justify-content:flex-end;">
							<li><a href="#/film/index">{{ lanuage("10152", "Movies") }}</a></li>
							<li><a href="#/sell/index">{{ lanuage("10153", "Food & Beverage") }}</a></li>
							<li><a href="#/experience/index">{{ lanuage("10154", "Experiences") }}</a></li>
							<li><a href="#/other/activity">{{ lanuage("10155", "Promotions") }}</a></li>
							<li><a href="#/event/index">{{ lanuage("10156", "Events") }}</a></li>
							<li class="u"><a href="#/other/U" >U+</a></li>
						</ul>
						<div class="menu-search" :class="{'open':search.c1}" style="display: none;">
							<div class="bon pad-10 pad-l-15 pad-r-15" @click="search.c1=search.c1?false:true"><img src="../../../assets/images/icon6.png" /></div>
							<div class="child" :class="{'cur':search.cname!=''}">
								<div class="fiex">
									<input type="search" v-model="search.cname" placeholder="Search video"  />
									<div  @click="goto('/other/search')">{{ lanuage("10157", "Search") }}</div>
								</div>
							</div>
							<i class="mask1" v-if="search.c1" @click="search.c1=false"></i>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
   
</template>
<script>
	import { mapState, mapActions, mapMutations } from "vuex";
	import { logout } from "@/api/mine";
	export default {
	name: 'heads',
		data(){
			return{
				 defaultPhoto: require("../../../../images/unloginPhoto.png"),
				headclass:'',
				menu:{},
				search:{
					c1:false,
					cname:''
				}
			}
		},
		mounted(){
			var that=this;
			$(window).scroll(function(){
                var s=$(this).scrollTop();
                if(s>200){
                    that.headclass='scroll'
                }else{
                    that.headclass=''
                }
            })

			

		},
		activated(){
			this.$forceUpdate()
		},
		computed:{
			...mapState(["userInfo"])
		},
		methods: {
			 ...mapMutations(["memoryData"]),
			async mov(){//加载影院数据
				await this.$store.dispatch('cityList/setCityList');
            	console.log(this.$store.state)
			},
			quit(){
            	this.$confirm('Confirm logout?')
            	.then(_ => {
					this.ext();
					this.delCookie("token");
					window.sessionStorage.removeItem('token');
					localStorage.removeItem('firstselect')
					this.memoryData({userInfo:""});
					this.$router.push("/login/index")
                	// done();
           		 })
            	.catch(_ => {});
       },
       async ext(){
        const res = await logout({
            method: "get",
            });
            if (res.code === 200) {}
       }
		}
	};
	</script>





// WEBPACK FOOTER //
// src/components/global/heads/index.vue